module.exports = __webpack_public_path__ + "static/media/logo1024x1024.3a024b3f.png";